import React, { Component } from 'react';
import {Map, InfoWindow, Marker, GoogleApiWrapper} from 'google-maps-react';

class MapContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      latlng:this.props.latlng
    };
  }

  render() {
    let height = "100vh";
    let width = "100%";
    if(window.outerWidth < 800){
      height = "30vh";
      width = "100%";
    }
    return (
      <Map
        style={{width:width,height:height}}
        google={this.props.google}
        zoom={6}
        initialCenter={{ lat: this.state.latlng[0], lng: this.state.latlng[1] }}
        center={{ lat: this.state.latlng[0], lng: this.state.latlng[1] }}
      >
        <Marker
          key={'1'}
          position={{ lat: this.state.latlng[0], lng: this.state.latlng[1] }}
        />
      </Map>
    );
  }
}

const MapWrapper = props => (
  <Map className="map" google={props.google} visible={false}>
    <MapContainer {...props} />
  </Map>
);

export default GoogleApiWrapper({
  apiKey: ('AIzaSyA_yyJYC2P02Vm2TkyuyPAESqqUkumuIzU')
})(MapWrapper)



// WEBPACK FOOTER //
// ./src/components/googleMap/index.js